import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { changerRoleActif } from '../service/utilisateur/utilisateur.service';

export default function RoleSwitcher() {
    const { user, setUser } = useAuth();
    const navigate = useNavigate();
    const [selectedRole, setSelectedRole] = useState(user?.role);
    const [isOpen, setIsOpen] = useState(false);

    if (!user || !user.roles || user.roles.length <= 1) {
        return null; // Ne pas afficher si l'utilisateur n'a qu'un seul rôle
    }

    const handleRoleChange = async (newRole: string) => {
        console.log('Changement de rôle vers:', newRole);
        const typedRole = newRole as 'ADMIN' | 'PROPRIETAIRE' | 'LOCATAIRE';
        setSelectedRole(typedRole); 
        setIsOpen(false);
        
        try {
            // Appel API pour mettre à jour le rôle actif dans la base de données
            await changerRoleActif(newRole);
            
            // Mettre à jour le rôle de l'utilisateur dans le contexte
            if (user) {
                const updatedUser: typeof user = { ...user, role: typedRole };
                setUser(updatedUser);
                
                // Stocker le nouveau rôle dans sessionStorage
                sessionStorage.setItem('user', JSON.stringify(updatedUser));
                
                // Rediriger vers la page appropriée en fonction du rôle
                switch (newRole) {
                    case 'ADMIN':
                        navigate('/');
                        break;
                    case 'PROPRIETAIRE':
                        navigate('/');
                        break;
                    case 'LOCATAIRE':
                        navigate('/');
                        break;
                    default:
                        navigate('/');
                }
            }
        } catch (error) {
            console.error('Erreur lors du changement de rôle:', error);
            // Afficher un message d'erreur à l'utilisateur
            alert('Erreur lors du changement de rôle. Veuillez réessayer.');
            // Revenir au rôle précédent
            setSelectedRole(user?.role);
        }
    };

    const getRoleLabel = (role: string) => {
        switch (role) {
            case 'ADMIN': return 'Administrateur';
            case 'PROPRIETAIRE': return 'Propriétaire';
            case 'LOCATAIRE': return 'Locataire';
            default: return role;
        }
    };

    const getRoleIcon = (role: string) => {
        switch (role) {
            case 'ADMIN': return '👑';
            case 'PROPRIETAIRE': return '🏠';
            case 'LOCATAIRE': return '🔑';
            default: return '👤';
        }
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center space-x-2 px-3 py-2 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors"
            >
                <span className="text-lg">{getRoleIcon(selectedRole || user.role)}</span>
                <span className="font-medium">{getRoleLabel(selectedRole || user.role)}</span>
                <svg
                    className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                    <div className="p-2">
                        <p className="text-xs text-gray-500 px-3 py-2 font-medium">Changer de rôle</p>
                        {user.roles.map((role) => (
                            <button
                                key={role}
                                onClick={() => handleRoleChange(role)}
                                className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md transition-colors ${
                                    role === (selectedRole || user.role)
                                        ? 'bg-blue-50 text-blue-700'
                                        : 'text-gray-700 hover:bg-gray-50'
                                }`}
                            >
                                <span className="text-xl">{getRoleIcon(role)}</span>
                                <span className="font-medium">{getRoleLabel(role)}</span>
                                {role === (selectedRole || user.role) && (
                                    <svg className="w-5 h-5 ml-auto text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
